import { render, staticRenderFns } from "./ExamineRevision_review.vue?vue&type=template&id=1e766ba4&style=height%3A%20100%25%3B"
import script from "./ExamineRevision_review.vue?vue&type=script&lang=js"
export * from "./ExamineRevision_review.vue?vue&type=script&lang=js"
import style0 from "./ExamineRevision_review.vue?vue&type=style&index=0&id=1e766ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports